module.exports = __webpack_public_path__ + "img/ds8.26a35c36.png";